"use client";

import { BUSINESS_ONE_TIME_TYPES, ONE_TIME_TYPES } from "@/features/quote/shared/quote-config";
import { ChoiceCard } from "@/features/quote/ui/ChoiceCard";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";
import { fieldBaseClass, labelClass } from "@/shared/ui/form/field-styles";

export function SubtypeStep() {
  const { state, update, autoAdvance, goToStep, step, stepReady, isBusiness } = useWizard();

  if (isBusiness) {
    return (
      <section>
        <StepHeading
          title="Hvilken type engangsopgave?"
          body="Vælg den type engangsopgave der passer bedst."
          maxW="max-w-[26ch]"
        />
        <div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 md:grid-cols-3">
          {BUSINESS_ONE_TIME_TYPES.map((et) => (
            <ChoiceCard
              key={et.value}
              selected={state.engangsSubtype === et.value}
              onClick={() => {
                update("engangsSubtype", et.value);
                if (et.value !== "andet") autoAdvance();
              }}
              icon={et.icon}
              title={et.label}
              body={et.body}
              compact
            />
          ))}
        </div>

        {state.engangsSubtype === "andet" && (
          <div className="mt-6">
            <label htmlFor="wiz-engangs-andet" className={labelClass}>
              Beskriv kort hvad der skal laves
            </label>
            <textarea
              id="wiz-engangs-andet"
              rows={3}
              placeholder="Fx 'Tæpperens af mødelokaler' eller 'Specialrengøring efter vandskade'…"
              value={state.engangsAndetDescription}
              onChange={(e) => update("engangsAndetDescription", e.target.value)}
              className={`${fieldBaseClass} min-h-20 resize-y`}
            />
          </div>
        )}

        <StepNav
          onBack={() => goToStep(step - 1)}
          onNext={() => goToStep(step + 1)}
          nextEnabled={stepReady("subtype")}
          nextLabel="Næste →"
        />
      </section>
    );
  }

  return (
    <section>
      <StepHeading
        title="Hvilken type engangsopgave?"
        body="Vælg den type engangsopgave der passer bedst."
      />
      <div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 md:grid-cols-3">
        {ONE_TIME_TYPES.map((et) => (
          <ChoiceCard
            key={et.value}
            selected={state.engangsSubtype === et.value}
            onClick={() => {
              update("engangsSubtype", et.value);
              autoAdvance();
            }}
            icon={et.icon}
            title={et.label}
            body={et.body}
            compact
          />
        ))}
      </div>

      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("subtype")}
        nextLabel="Næste →"
      />
    </section>
  );
}
